<template>
  <v-navigation-drawer
    id="appDrawer"
    :mini-variant.sync="mini"
    :dark="$vuetify.dark"
    app
    v-model="drawer"
    width="260"
  >
    <v-toolbar color="primary darken-1" dark>
      <img
        src="../../../assets/img/m.png"
        height="36"
        alt="Vue Material Admin Template"
      />
      <v-toolbar-title class="ml-0 pl-3">
        <span class="hidden-sm-and-down">GESCOL</span>
      </v-toolbar-title>
    </v-toolbar>
    <VuePerfectScrollbar class="scroll-area" :settings="settings">
      <v-list dense expand>
        <v-subheader>Sede: {{ user.headquartersName }}</v-subheader>
        <v-divider></v-divider>
        <template v-for="(item, index) in menus">
          <div :key="index">
            <v-subheader>{{ item.header }}</v-subheader>
            <template v-if="item.existItems">
              <v-list-group
                v-for="option in item.options"
                :group="item.group"
                no-action="no-action"
                :prepend-icon="option.icon"
                :key="option.optionCode"
              >
                <template v-slot:activator>
                  <v-list-item-content>
                    <v-list-item-title>{{
                      option.optionName
                    }}</v-list-item-title>
                  </v-list-item-content>
                </template>
                <v-list-item
                  v-for="subItem in option.children"
                  :key="subItem.optionCode"
                  :to="subItem.path"
                >
                  <v-list-item-content>
                    <v-list-item-title>{{
                      subItem.optionName
                    }}</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list-group>
            </template>
            <v-list-item-group v-else>
              <template v-for="item in item.options">
                <v-list-item :to="item.path" :key="item.optionCode">
                  <v-list-item-icon>
                    <v-icon>{{ item.icon }}</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title>{{ item.optionName }}</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </template>
            </v-list-item-group>
            <v-divider v-if="item.divider"></v-divider>
          </div>
        </template>
      </v-list>
    </VuePerfectScrollbar>
  </v-navigation-drawer>
</template>

<script>
import { mapGetters } from 'vuex';
import menuOptions from '@/infrastructure/utils/menu';
import VuePerfectScrollbar from 'vue-perfect-scrollbar';
export default {
  name: 'AppDrawer',
  components: {
    VuePerfectScrollbar,
  },
  data: () => ({
    mini: false,
    drawer: true,
    menus: [],
    settings: {
      maxScrollbarLength: 160,
    },
  }),
  computed: {
    ...mapGetters('login', ['accessOptionsByProfile', 'user']),
  },
  created() {
    this.menus = menuOptions.reduce((acc, menu) => {
      const options = menu.options.reduce((acc, optionCode) => {
        const resultAccessOptions = this.accessOptionsByProfile.find(
          (option) => option.optionCode === optionCode
        );
        if (resultAccessOptions) {
          acc.push(resultAccessOptions);
        }
        return acc;
      }, []);
      if (options.length > 0) {
        acc.push({ ...menu, options });
      }
      return acc;
    }, []);

    window.getApp.$on('APP_DRAWER_TOGGLED', () => {
      this.drawer = !this.drawer;
    });
  },
};
</script>

<style lang="scss">
.scroll-area {
  height: calc(100vh - 90px);
}
</style>
